import { render, staticRenderFns } from "./CustomizeMetalX.vue?vue&type=template&id=2074c2cc&scoped=true"
import script from "./CustomizeMetalX.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalX.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalX.vue?vue&type=style&index=0&id=2074c2cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2074c2cc",
  null
  
)

export default component.exports